// extracted by mini-css-extract-plugin
export var featuredMediaImage = "FeaturedMediaImage-module--featured-media-image--HuwCS";
export var fullHeight = "FeaturedMediaImage-module--full-height--YjapX";
export var image = "FeaturedMediaImage-module--image--0g5A4";